// extracted by mini-css-extract-plugin
export default {"vipWithdrawalLimit":"vipWithdrawalLimit_vipWithdrawalLimit__gwleR","upgrade_title":"vipWithdrawalLimit_upgrade_title__XA5Vu"};